import { Box, Text, Flex } from "@chakra-ui/react";
import { Row, Col } from "antd";
import { Control, UseFormSetValue } from "react-hook-form";
import Field from "components/Input/Field";
import { UseFormWatch } from "react-hook-form";
import SelectContaBancaria from "components/Input/SelectContaBancaria";
import { FormAcordo } from "features/acordo/typings";
import TabelaParcela from "./components/TabelaParcela";
import InputMoney from "ui/components/Input/InputMoney";
import CollapseSwitch from "components/CollapseSwitch";

interface PagamentoParcelasProps {
  control: Control<FormAcordo>;
  watch: UseFormWatch<FormAcordo>;
  setValue: UseFormSetValue<FormAcordo>;
  total: number;
  totalComposicoes: number;
  onDistributionChange?: (isDitributedCorrectly: boolean) => any;
}

function PagamentoParcelas({
  control,
  setValue,
  watch,
  total,
  onDistributionChange,
  totalComposicoes,
}: PagamentoParcelasProps) {
  const entrada = watch("temEntrada");

  return (
    <Box flex={1}>
      <Text fontSize="18px" fontWeight="medium" my={"32px"}>
        Pagamento
      </Text>
      <CollapseSwitch
        onChange={(v) => {
          setValue("temEntrada", v);
          if (!v) {
            setValue("entrada", null);
          }
        }}
        open={!!entrada}
        title="Entrada"
      >
        <Flex mt={entrada ? "32px" : undefined} gridGap="16px">
          {entrada ? (
            <Row gutter={16} style={{ width: "100%" }}>
              <Col sm={4}>
                <Field
                  label="Entrada"
                  control={control}
                  name="entrada.valor"
                  render={({ field, isInvalid }) => (
                    <InputMoney
                      isInvalid={isInvalid}
                      {...field}
                      maxValue={totalComposicoes}
                    />
                  )}
                />
              </Col>
              <Col sm={8}>
                <Field
                  label="Conta de pagamento"
                  control={control}
                  rules={{
                    required: !!watch("entrada.valor"),
                  }}
                  name="entrada.contaBancariaId"
                  render={({ field, isInvalid }) => (
                    <SelectContaBancaria
                      isInvalid={isInvalid}
                      {...field}
                      incluirInativas={false}
                    />
                  )}
                />
              </Col>
              <Col sm={8}>
                <Field
                  label="Data de vencimento"
                  control={control}
                  name="entrada.dataVencimento"
                  rules={{
                    max: "2100-01-01",
                  }}
                  inputProps={{
                    type: "date",
                    max: "2100-01-01",
                  }}
                />
              </Col>
            </Row>
          ) : null}
        </Flex>
      </CollapseSwitch>

      <Box mt={3}>
        <TabelaParcela
          total={total}
          control={control}
          watch={watch}
          setValue={setValue}
          onDistributionChange={onDistributionChange}
        />
      </Box>

      <Text fontSize="18px" fontWeight="medium" my={"32px"}>
        Taxas das parcelas
      </Text>
      <Row gutter={16}>
        <Col sm={8}>
          <Field
            control={control}
            label="Taxa de juros (%)"
            name="taxaJurosMensal"
            render={({ field, isInvalid }) => (
              <InputMoney
                isInvalid={isInvalid}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        </Col>
        <Col sm={8}>
          <Field
            control={control}
            label="Taxa de multa (%)"
            name="taxaMulta"
            render={({ field, isInvalid }) => (
              <InputMoney
                isInvalid={isInvalid}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        </Col>
        {/* <Col sm={8}>
          <Field
            control={control}
            label="Desconto (%)"
            name="desconto"
            render={({ field, isInvalid }) => (
              <InputMoney
                isInvalid={isInvalid}
                value={field.value}
                onChange={field.onChange}
              />
            )}
          />
        </Col> */}
      </Row>
    </Box>
  );
}

export default PagamentoParcelas;
